<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius frame-accounts heig-frame-equipment-group userTable">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-default-table 
                        :settings="tableConfig" 
                        :table-items="tableItems" 
                        @load-items="getTableData" 
                        @delete-items="deleteItems" 
                        @new-item="createOrEditItem" 
                        @row-click="createOrEditItem" 
                        :show-grid="showGrid" 
                        @import-items="importCompany"
                        @export="exportItems"
                        ref="gofixTable">
                        <template slot="gofix_table:show-mold" slot-scope="{gridData, tableSelected, actionStatus}">
                            <div class="pl-15 pr-15">
                                <b-row v-if="actionStatus.showFilter">
                                    <b-col md="1">
                                        <gofix-form-input label="ID" v-model="pages.filter.id.value" @change="searchClient"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Name" v-model="pages.filter.name.value" @change="searchClient"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Mailing Address" v-model="pages.filter.email.value" @change="searchClient"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Mobile" v-model="pages.filter.phone.value" @change="searchClient"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Contact Person" v-model="pages.filter.contact_name.value" @change="searchClient"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-20 rowOrg">
                                    <b-col :key="index" md="4" v-for="(item, index) in gridData">
                                        <div class="boxOrg">
                                            <div class="title d-flex align-items-baseline">
                                                <div class="custom-control custom-checkbox custom-control-inline ml-0">
                                                    <input type="checkbox" :value="item.id" v-model="tableSelected.selected" class="custom-control-input" :id="'customInChk'+item.id">
                                                    <label class="custom-control-label" :for="'customInChk'+item.id"></label>
                                                </div>
                                                <strong class="mr-3 ml-3">{{item.id}}</strong>
                                                <div class='d-table-cell'><strong>{{item.name}}</strong></div>
                                            </div>
                                            <div class="content" @click.stop="createOrEditItem(item)">
                                                <p><label>Company Type</label> {{item.company_type}} </p>
                                                <p><label>Contact Person</label> {{item.contact_name }} </p>
                                                <p><label>Mobile</label> {{item.phone}} </p>
                                                <p><label>Email</label> {{item.email}} </p>
                                                <p><label>Address</label>
                                                    {{ item.display_address}}
                                                </p>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </template>
                        <template slot="gofix_table:after-control-left">
                            <li class="control-item showGrid" key="grid-view">
                                <a class="control-item-link cursor-pointer showGrid" v-bind:class="{'active': showGrid}" @click="toggleList" title="Grid View" v-b-tooltip.hover><i class="fa fa-th"></i></a>
                            </li>
                            <li class="control-item showGrid" key="table-view">
                                <a class="control-item-link cursor-pointer showGrid" v-bind:class="{'active': !showGrid}" @click="toggleList" title="Table view" v-b-tooltip.hover><i class="fa fa-th-list"></i></a>
                            </li>
                        </template>
                        <template slot="gofix_table:before-control-right">
                            <div class="control">
                                <ul class="list-inline">
                                    <li @click="setCompanyType('')" v-bind:class="{'active': this.companyType.value == 'all_companies' || this.companyType.value == ''}">All Companies</li>
                                    <li @click="setCompanyType('fm_companies')" v-bind:class="{'active': this.companyType.value == 'fm_companies' }">FM Companies</li>
                                    <li @click="setCompanyType('supplier')" v-bind:class="{'active': this.companyType.value == 'supplier' }">Supplier</li>
                                    <li @click="setCompanyType('client')" v-bind:class="{'active': this.companyType.value == 'client' }">Clients</li>
                                </ul>
                            </div>
                        </template>
                    </gofix-default-table>
                </b-col>
            </b-row>
            <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="titleModal" hide-footer :centered="true" ref="modal-Create">
                <b-form class="pb-20" v-bind:class="{'run-loading':Loadings.create}">
                    <gofix-form-dropdown class="gofixInputNoMinWidth" vLabel="text" :reduce="option => option.value" :clearable="false" required label="Company Type" v-model="companyType.value" :options="optionType">
                    </gofix-form-dropdown>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="APPLY" @click="addItem" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'

export default {
    name: 'organisations',
    components: {},
    data() {
        let filter = JSON.parse(JSON.stringify(filters['companies']))
        return {
            tableConfig: {
                name: 'account-companies',
                controls: {
                    create: this.$checkRole(this.$accessModule.companies, 'create'),
                    delete: this.$checkRole(this.$accessModule.companies, 'delete')
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: "id",
                sortDirection: "desc",
            },
            tableItems: [],
            showGrid: false,
            pages: {
                isCMS: '1',
                page: 1,
                limit: 100,
                totalPage: 1,
                filter: JSON.parse(JSON.stringify(filters['companies']))
            },
            allSelected: false,
            selected: [],
            isAction: false,
            titleModal: 'create Company',
            show: 'grid',
            nameTable: 'tableCompany',
            optionType: [
                {
                    value: 'fm_companies',
                    text: 'FM Company'
                },
                {
                    value: 'client',
                    text: 'Client'
                },
                {
                    value: 'supplier',
                    text: 'Supplier'
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            companyType: 'AllCompanyController/companyType',
            Loadings: 'AllCompanyController/Loadings'
        })
    },
    created() {},
    watch: {
        "pages.filter.name.value": function(val) {
            this.$refs.gofixTable.tableRequest.filter.name.value = val;
        },
        "pages.filter.id.value": function(val) {
            this.$refs.gofixTable.tableRequest.filter.id.value = val;
        },
        "pages.filter.email.value": function(val) {
            this.$refs.gofixTable.tableRequest.filter.email.value = val;
        },
        "pages.filter.phone.value": function(val) {
            this.$refs.gofixTable.tableRequest.filter.phone.value = val;
        },
        "pages.filter.contact_name.value": function(val) {
            this.$refs.gofixTable.tableRequest.filter.contact_name.value = val;
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            if (this.companyType.value) {
                switch (this.companyType.value) {
                    case 'fm_companies':
                        tableRequest.filter.is_supplier = undefined;
                        tableRequest.filter.is_client = undefined;
                        tableRequest.filter.is_fm_company = { type: 'boolean', value: true };
                        break;
                    case 'supplier':
                        tableRequest.filter.is_supplier = { type: 'boolean', value: true };
                        tableRequest.filter.is_client = undefined;
                        tableRequest.filter.is_fm_company = undefined;
                        break;
                    case 'client':
                        tableRequest.filter.is_supplier = undefined;
                        tableRequest.filter.is_client = { type: 'boolean', value: true };
                        tableRequest.filter.is_fm_company = undefined;
                        break;
                    default:
                        tableRequest.filter.is_supplier = undefined;
                        tableRequest.filter.is_client = undefined;
                        tableRequest.filter.is_fm_company = undefined;
                }
            }
            await this.$store.dispatch("AllCompanyController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response.data.data);
                })
                .catch(err => {
                    this.$alertNotification("Can not load list of companies", "danger");
                    reject();
                })
        },
        createOrEditItem(item = null) {
            if (item) {
                this.$store.commit('AllCompanyController/setOrganizationItems', item);
                if (this.companyType.value == '' || this.companyType.value == 'all_companies') {
                    if (item.is_fm_company) {
                        return this.$router.push(`${this.$route.path}/${item.id}`);
                    }
                    if (item.is_supplier) {
                        return this.$router.push(`${this.$route.path}/supplier/${item.id}`);
                    }
                    return this.$router.push(`${this.$route.path}/client/${item.id}`);
                }
                if (this.companyType.value == 'fm_companies') {
                    return this.$router.push(`${this.$route.path}/${item.id}`);
                }
                return this.$router.push(`${this.$route.path}/${this.companyType.value}/${item.id}`);
            }
            this.companyType.value = ''
            this.$refs['modal-Create'].show()
        },
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            this.$store.dispatch("AllCompanyController/deleteItems", ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'company'))
                })
                .catch(err => {
                    console.error("Got nothing from server. Prompt user to check internet connection and try again")
                });
        },
        setCompanyType(company_type) {
            this.companyType.value = company_type;
            switch (company_type) {
                case 'fm_companies':
                    this.$refs.gofixTable.tableRequest.filter.is_supplier = undefined;
                    this.$refs.gofixTable.tableRequest.filter.is_client = undefined;
                    this.$refs.gofixTable.tableRequest.filter.is_fm_company = { type: 'boolean', value: true };
                    break;
                case 'supplier':
                    this.$refs.gofixTable.tableRequest.filter.is_supplier = { type: 'boolean', value: true };
                    this.$refs.gofixTable.tableRequest.filter.is_client = undefined;
                    this.$refs.gofixTable.tableRequest.filter.is_fm_company = undefined;
                    break;
                case 'client':
                    this.$refs.gofixTable.tableRequest.filter.is_supplier = undefined;
                    this.$refs.gofixTable.tableRequest.filter.is_client = { type: 'boolean', value: true };
                    this.$refs.gofixTable.tableRequest.filter.is_fm_company = undefined;
                    break;
                default:
                    this.companyType.value = '';
                    this.$refs.gofixTable.tableRequest.filter.is_supplier = undefined;
                    this.$refs.gofixTable.tableRequest.filter.is_client = undefined;
                    this.$refs.gofixTable.tableRequest.filter.is_fm_company = undefined;
            }
            this.$refs.gofixTable.reloadTableKeepFilter();
        },
        searchClient() {
            this.$refs.gofixTable.reloadTableKeepFilter();
        },
        addItem() {
            if (this.companyType.value == '') {
                return this.$alertNotification("Company Type is required.", "danger");
            }

            if (this.companyType.value == '' || this.companyType.value == 'fm_companies') {
                return this.$router.push(`${this.$route.path}/0`);
            }

            return this.$router.push(`${this.$route.path}/${this.companyType.value}/0`);
        },
        toggleList() {
            this.showGrid = !this.showGrid;
        },
        async importCompany(callback) {
            
            const {file, resolve, reject} = await callback();

            let contractID = 0;

            if ( !this.$refs.gofixTable.tableRequest.filter.is_supplier ) {
                this.$alertNotification('This function is not available yet', 'danger');
                resolve();
                return false;
            }

            if ( this.$refs.gofixTable.tableRequest.filter.contract_id.value ) {
                contractID = this.$refs.gofixTable.tableRequest.filter.contract_id.value;
            }

            await this.$store.dispatch(`OrganizationController/importCompany`, {
                fileImport: file,
                contract_id: contractID,
                is_supplier: this.$refs.gofixTable.tableRequest.filter.is_supplier.value,
            })
            .then(response => {
                let variant = 'success';
                let msg = this.$notificationV2('importing', 'company');
                let result = response.data.data;
                if (result.data && result.data.count && result.data.count.failed) {
                    variant = 'danger';
                    msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                }

                this.$alertNotification(msg, variant);
                resolve();
            })
            .catch(error => {
                reject(error);
            });
        },
        exportItems(tableRequest) {
            let request = JSON.parse(JSON.stringify(tableRequest));
            this.$store.dispatch('OrganizationController/exportOrganizations', request)
                .then(response => {
                    let nameFile = 'Companies.xlsx';
                    if(response.headers["content-disposition"]) {
                        let arrTemp = response.headers["content-disposition"].split("filename=");
                        if(arrTemp[1]) {
                            nameFile = arrTemp[1].replaceAll('"', "");
                        }
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
        },
    }
}
</script>